import {TimelineLite} from "gsap";
import {WalkOfShame} from "../../WalkOfShame";
import {IBetWinData} from "../../server/data/IWalkOfShameData";
import {WalkOfShameParsedGameData} from "../../server/data/WalkOfShameParsedGameData";
import {WalkOfShameReelController} from "../../reels/WalkOfShameReelController";
import {WalkOfShameSymbol} from "../../symbol/WalkOfShameSymbol";

export class IndividualWinController {

    private _currentTimeline: TimelineLite | null;
    private _stopped: boolean;

    constructor() {
    }

    public start(): void {
        this._stopped = false;
        if (WalkOfShame.model.parsedGameData.betWins.length > 0 && WalkOfShame.model.parsedGameData.singleWin > 0) {
            // Add a small delay for the first time, so we don't start to play before the autoPlay start next spin.
            this.playNextBetWin(0, 1);
        }
    }

    public async stop(): Promise<any> {
        this._stopped = true;
        if (this._currentTimeline && this._currentTimeline.isActive()) {
            await this._currentTimeline.progress(1);
        }
        this._currentTimeline = null;

        // #136
        WalkOfShame.reels.forEach((reel: WalkOfShameReelController) => {
            reel.reelView.allSymbols.forEach((sym: WalkOfShameSymbol) => {
                sym.killStateTl();
            });
        });

        await Promise.resolve();
    }

    private playNextBetWin(index: number, delay: number): void {
        if (this._stopped) {
            return;
        }

        const data: WalkOfShameParsedGameData = WalkOfShame.model.parsedGameData;
        if (index === data.betWins.length) {
            index = 0;
        }
        const tl: TimelineLite = new TimelineLite();

        // #72
        if (WalkOfShame.model.parsedGameData.brokeTheBank) {
            const winData: IBetWinData = data.betWins[0];
            winData.reelWinPositions = WalkOfShame.model.parsedGameData.reelWinPositionsAll;
            winData.multipliedAmount = WalkOfShame.model.parsedGameData.totalWin;

            tl.add(this.getBetWayAnimation(winData), delay);
        } else {
            tl.add(this.getBetWayAnimation(data.betWins[index]), delay);
            tl.add(() => {
                if (!this._stopped) {
                    this.playNextBetWin(index + 1, 0);
                }
            });
        }

        this._currentTimeline = tl;
    }

    private getBetWayAnimation(winData: IBetWinData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            if (!this._stopped) {
                WalkOfShame.winWays.showToggleWinAmountNWays(winData.multipliedAmount, winData.numberOfCombinations);
            }
        }, 0);
        winData.reelWinPositions.forEach((reelWin: boolean[], reelId: number) => {
            reelWin.forEach((symWin: boolean, symId: number) => {
                if (symWin) {
                    tl.add(WalkOfShame.getWinAnimationForSymbol(reelId, symId + 1, false), 0);
                }
            });
        });
        tl.to(this, {
            duration: 0.5
        });

        return tl;
    }
}